// extracted by mini-css-extract-plugin
export const wrapper = "br_c5";
export const overlay = "br_bt";
export const circleLoading = "br_c6";
export const linearLoading = "br_c7";